import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × BON PARFUMEUR: Synesthetic fragrance meets geometric perception
// Color bands, coded labels, olfactory geometry
export function VasarelyBonparfumeurMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="bonparf-band1" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#E8F5E9" />
          <stop offset="50%" stopColor="#C8E6C9" />
          <stop offset="100%" stopColor="#A5D6A7" />
        </linearGradient>
        <linearGradient id="bonparf-band2" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#FFF3E0" />
          <stop offset="50%" stopColor="#FFE0B2" />
          <stop offset="100%" stopColor="#FFCC80" />
        </linearGradient>
        <linearGradient id="bonparf-band3" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#E1F5FE" />
          <stop offset="50%" stopColor="#B3E5FC" />
          <stop offset="100%" stopColor="#81D4FA" />
        </linearGradient>
        <linearGradient id="bonparf-band4" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#FCE4EC" />
          <stop offset="50%" stopColor="#F8BBD0" />
          <stop offset="100%" stopColor="#F48FB1" />
        </linearGradient>
      </defs>

      {/* White laboratory background */}
      <rect x="0" y="0" width="794" height="1123" fill="#FAFAFA" />

      <g transform="translate(397 540)">
        {/* Color bands (scent families) */}
        {[
          { y: -400, h: 200, grad: "bonparf-band1", label: "01" },
          { y: -200, h: 200, grad: "bonparf-band2", label: "02" },
          { y: 0, h: 200, grad: "bonparf-band3", label: "03" },
          { y: 200, h: 200, grad: "bonparf-band4", label: "04" },
        ].map((band, i) => (
          <g key={i}>
            <rect
              x="-397"
              y={band.y}
              width="794"
              height={band.h}
              fill={`url(#${band.grad})`}
              opacity="0.2"
            />
            <text
              x="-350"
              y={band.y + 30}
              fontFamily="Courier, monospace"
              fontSize="20"
              fill="#000000"
              opacity="0.3"
              fontWeight="700"
            >
              {band.label}
            </text>
          </g>
        ))}

        {/* Coded labels grid */}
        {[
          { x: -200, y: -250, code: "101", color: "#81C784" },
          { x: -200, y: -150, code: "201", color: "#FFB74D" },
          { x: -200, y: -50, code: "301", color: "#4FC3F7" },
          { x: -200, y: 50, code: "401", color: "#F06292" },
          { x: -200, y: 150, code: "501", color: "#BA68C8" },
          { x: -200, y: 250, code: "601", color: "#FF8A65" },
        ].map((label, i) => (
          <g key={i}>
            <rect
              x={label.x}
              y={label.y - 20}
              width="80"
              height="40"
              fill="none"
              stroke={label.color}
              strokeWidth="2"
              opacity="0.5"
            />
            <text
              x={label.x + 40}
              y={label.y + 5}
              fontFamily="Courier, monospace"
              fontSize="14"
              fill={label.color}
              textAnchor="middle"
              fontWeight="700"
            >
              {label.code}
            </text>
          </g>
        ))}

        {/* Olfactory geometry */}
        {Array.from({ length: 16 }).map((_, i) => {
          const angle = (i * Math.PI) / 8;
          const r1 = 80;
          const r2 = 200;
          const colors = ["#81C784", "#FFB74D", "#4FC3F7", "#F06292"];
          
          return (
            <line
              key={i}
              x1={Math.cos(angle) * r1}
              y1={Math.sin(angle) * r1}
              x2={Math.cos(angle) * r2}
              y2={Math.sin(angle) * r2}
              stroke={colors[i % 4]}
              strokeWidth="1"
              opacity="0.3"
            />
          );
        })}

        {/* Synesthetic circles */}
        {Array.from({ length: 8 }).map((_, i) => {
          const r = 80 + i * 25;
          const colors = ["#81C784", "#FFB74D", "#4FC3F7", "#F06292"];
          
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={colors[i % 4]}
              strokeWidth="2"
              opacity={0.4 - i * 0.04}
            />
          );
        })}

        {/* Central scent molecule */}
        <circle cx="0" cy="0" r="60" fill="#81C784" opacity="0.15" />
        <circle cx="0" cy="0" r="50" fill="#FFB74D" opacity="0.15" />
        <circle cx="0" cy="0" r="40" fill="#4FC3F7" opacity="0.15" />
        <circle cx="0" cy="0" r="30" fill="#F06292" opacity="0.15" />
        <circle cx="0" cy="0" r="20" fill="#000000" opacity="0.4" />
      </g>

      {/* Scent algorithm */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="Courier, monospace" fontSize="9" fill="#666" letterSpacing="2">
        SCENT ALGORITHM
      </text>
    </g>
  );
}
